<template>
  <div class="page-footer">
    <a class="txt2" href="https://admins-egypt.com" target="_blank">
      {{ $t("copyRight") }}
    </a>
  </div>
</template>

<script>
export default {
  name: "Footer",
};
</script>

<style lang="scss"></style>
